import { ErrorIcon, SvgIconProps, Tag, Tooltip, WarningIcon } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { IncidentSeverity, incidentSeverityOf } from '../domain/ShipmentIncident'

function tooltipTermFor(code: string): string {
  const terms: Record<string, string> = {
    riskOfDelay: 'shipment-incident-tooltip-riskOfDelay',
    confirmedDisruption: 'shipment-incident-tooltip-confirmedDisruption',
    cargoBlocked: 'shipment-incident-tooltip-cargoBlocked',
  }
  return terms[code] ?? ''
}

type SeverityColor = 'warning' | 'error'

type SeverityConfig = {
  icon: FC<SvgIconProps>
  color: SeverityColor
}

const severityConfigs: Record<IncidentSeverity, SeverityConfig> = {
  [IncidentSeverity.warning]: {
    icon: WarningIcon,
    color: 'warning',
  },
  [IncidentSeverity.error]: {
    icon: ErrorIcon,
    color: 'error',
  },
}

function severityConfig(code: string): SeverityConfig {
  const severity = incidentSeverityOf(code)
  return severityConfigs[severity]
}

type IncidentFlagTagProps = {
  code: string
  detailed?: boolean
}

export const IncidentFlagTag: FC<IncidentFlagTagProps> = ({ code, detailed }) => {
  const { translate } = useI18n()

  const { icon: IconComponent, color } = severityConfig(code)

  return (
    <Tooltip title={translate(tooltipTermFor(code))}>
      {detailed ? (
        <Tag
          icon={<IconComponent />}
          color={color}
          label={translate(`${code}-title`)}
          sx={{ marginLeft: 1, paddingLeft: 0.5 /* Otherwise the warning icon is too close to the edge of the tag */ }}
        />
      ) : (
        <span>
          <IconComponent color={color} />
        </span>
      )}
    </Tooltip>
  )
}
